import React from "react";

// Evidenzia nel testo: indirizzi email (blu), numeri di telefono (nero), siti web (verde) — tutti in grassetto
// Nessun lookbehind: compatibile anche con Safari/WebView meno recenti (PWA)
const RX_EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g;
const RX_URL = /(?:https?:\/\/|www\.)[^\s<>"')\]]+|(^|[^\w@.-])([a-z0-9-]+(?:\.[a-z0-9-]+)*\.(?:it|com|eu|net|org|info|io|es|fr|de|uk|ch|biz|shop|app)(?:\/[^\s<>"')\]]*)?)(?![\w@])/gi;
const RX_TEL = /(^|[^\w./-])(\+?\d(?:[\d\s./-]{6,18})\d)(?![\w])/g;

export const STILI = {
  email: { color: "#1a6fd4", fontWeight: 800, textDecoration: "none" },
  url: { color: "#1b8a3a", fontWeight: 800, textDecoration: "none" },
  tel: { color: "#111111", fontWeight: 800, textDecoration: "none" },
};

function isTel(s) {
  const cifre = s.replace(/\D/g, "");
  return cifre.length >= 9 && cifre.length <= 13 && !/^\d{4}[./-]\d{2}/.test(s) && !/\d{1,2}[./]\d{1,2}[./]\d{2,4}/.test(s);
}

// Segmenti [{tipo, testo}] con tipo null per il testo normale
export function segmenta(testo) {
  const trov = [];
  for (const [tipo, rx] of [["email", RX_EMAIL], ["url", RX_URL], ["tel", RX_TEL]]) {
    rx.lastIndex = 0;
    let m;
    while ((m = rx.exec(testo))) {
      // Per url/tel il gruppo 1 è il carattere precedente (non fa parte del match utile)
      let start = m.index;
      let txt = m[0];
      if (tipo !== "email" && m[1] !== undefined) {
        start += m[1].length;
        txt = m[2] !== undefined ? m[2] : m[0].slice(m[1].length);
      }
      if (!txt) continue;
      if (tipo === "tel" && !isTel(txt)) continue;
      trov.push({ tipo, start, end: start + txt.length, testo: txt });
    }
  }
  trov.sort((a, b) => a.start - b.start || b.end - a.end);
  const out = [];
  let pos = 0;
  for (const t of trov) {
    if (t.start < pos) continue; // sovrapposto (es. dominio dentro un'email)
    if (t.start > pos) out.push({ tipo: null, testo: testo.slice(pos, t.start) });
    out.push(t);
    pos = t.end;
  }
  if (pos < testo.length) out.push({ tipo: null, testo: testo.slice(pos) });
  return out;
}

function hrefDi(tipo, testo) {
  if (tipo === "email") return "mailto:" + testo;
  if (tipo === "tel") return "tel:" + testo.replace(/[\s./-]/g, "");
  return /^https?:\/\//i.test(testo) ? testo : "https://" + testo;
}

// Testo semplice → nodi React
export function evidenziaTesto(testo) {
  return segmenta(testo || "").map((s, i) =>
    s.tipo ? (
      <a key={`${i}-${s.testo}`} href={hrefDi(s.tipo, s.testo)} style={STILI[s.tipo]} className={`ev-${s.tipo}`} target={s.tipo === "url" ? "_blank" : undefined} rel="noopener noreferrer">
        {s.testo}
      </a>
    ) : (
      s.testo
    )
  );
}

// Documento HTML (iframe) → avvolge le occorrenze nei nodi di testo
export function evidenziaDoc(d) {
  if (!d?.body || d.body.dataset.evidenziato) return;
  d.body.dataset.evidenziato = "1";
  const walker = d.createTreeWalker(d.body, 4, {
    acceptNode: (n) => {
      const p = n.parentElement;
      if (!p || !n.nodeValue.trim()) return 2;
      if (/^(SCRIPT|STYLE|TEXTAREA|TITLE)$/.test(p.tagName)) return 2;
      return 1;
    },
  });
  const nodi = [];
  while (walker.nextNode()) nodi.push(walker.currentNode);
  for (const n of nodi) {
    const seg = segmenta(n.nodeValue);
    if (!seg.some((s) => s.tipo)) continue;
    const dentroLink = !!n.parentElement.closest("a");
    const frag = d.createDocumentFragment();
    for (const s of seg) {
      if (!s.tipo) {
        frag.appendChild(d.createTextNode(s.testo));
        continue;
      }
      const el = d.createElement(dentroLink ? "span" : "a");
      if (!dentroLink) {
        el.href = hrefDi(s.tipo, s.testo);
        if (s.tipo === "url") el.target = "_blank";
      }
      Object.assign(el.style, { color: STILI[s.tipo].color, fontWeight: "800", textDecoration: "none" });
      el.className = "ev-" + s.tipo;
      el.textContent = s.testo;
      frag.appendChild(el);
    }
    n.parentNode.replaceChild(frag, n);
  }
}
